export function getSubstitutedEndpoint(
	endPoint: string,
	routeParams: Record<string, string>,
) {
	const modifiedUrlParts = endPoint.split('/').map((val) => {
		if (val.startsWith(':')) {
			const dynamicKey = val.replace(':', '');
			return routeParams[dynamicKey] ?? val;
		}
		return val;
	});

	return modifiedUrlParts.join('/');
}